<section class="col-xs-12 col-md-12 mt-5" id="thanksave"
  *ngIf="enablePage.showSaveThankYouPage">
  <div class="thankorder_box">
  <!--   <ng-container *ngIf="!isAsAgent;else asmtext"> -->
    <div class="thankorder_head"><span  [innerHtml]="data.t2content"></span><span class="seasonspace">{{seasonValue | seasonspilt}}</span>
    <span [innerHtml]="data.subHeadLine"></span></div>
    <div class="thanksave_text">{{"startorderUk.saveorderThankyoumsg" | cxTranslate}}</div>

    <div class="thankordersave" [innerHtml]="data.headLine"></div>
 <!--  </ng-container>
    <ng-template #asmtext>
      <div  class="thankorder_head">The pre-order has been sent to the customer for their confirmation</div>
   </ng-template> -->
  
  <a class="my-order-anchor showPopupclick" (click)="handleOnOrdersClick()">
    <div class="viewbutton">{{"startorderUk.viewOrders" | cxTranslate}}</div>
  </a>
  <div class="omsjob_code" *ngIf="data?.t2linkurl">{{data?.t2linkurl}}</div>
</div>
</section>

